import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { IUserRole, ICreateUserRole } from './user-role.interface'
import { IUpdateDTModel } from '../helpers/update-model.interface'
import { BehaviorSubject, catchError, filter, finalize, firstValueFrom } from 'rxjs'
import { HttpErrorHandlerService } from '../helpers/http-error-handler.service'
import { Observable } from 'rxjs/internal/Observable'
import { API_ENDPOINT_PATH, API_HTTP_HEADERS } from "../helpers/api-constant";


@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  readonly #headers: HttpHeaders
  readonly #urlEndpoint: string

  private readonly hasModified$: BehaviorSubject<{ _id: string }> = new BehaviorSubject<{ _id: string }>({ _id: '-1' })
  private readonly modifiedRoleId$: Observable<{ _id: string }> = this.hasModified$.asObservable()
    .pipe(
    filter((userRole: { _id: string }) => userRole._id !== '-1'),
    finalize(() => console.log('userRole$ - Observable completed.'))
  )

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandlerService: HttpErrorHandlerService
  ) {
    this.#urlEndpoint = `${API_ENDPOINT_PATH}/userRole`;
    this.#headers = new HttpHeaders(API_HTTP_HEADERS);
  }

  notifyRoleModification(id: string): void {
    this.hasModified$.next({ _id: id })
  }

  observeRoleModification$(): Observable<{ _id: string }> {
    return this.modifiedRoleId$
  }

  private getUrl(): string {
    return `${this.#urlEndpoint}`
  }

  private getHeader(): HttpHeaders {
    return this.#headers
  }

  async upsertOne(payload: IUserRole | ICreateUserRole): Promise<{}|IUserRole|IUpdateDTModel> {
    const result = this.http.post<IUserRole>(`${this.getUrl()}`, payload,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
    return await firstValueFrom(result)
  }

  async getById(id: string, attr?: string): Promise<{}|IUserRole> {
    let queryUrl = `${this.getUrl()}/${id}`
    if (attr) { queryUrl += `?attr=${attr}`}

    const result = this.http.get<IUserRole>(`${queryUrl}`,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
    return await firstValueFrom(result)
  }

  async listAll(params?: string): Promise<IUserRole[]> {
    let queryUrl = `${this.getUrl()}`
    if (params) { queryUrl += `?${params}` }

    const result = this.http.get<IUserRole[]>(`${queryUrl}`,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForRecords))
    return await firstValueFrom(result)
  }

  async deleteById(id: string): Promise<void> {
	  const headers = this.getHeader().delete('Content-Type').delete('content-type');

    const result = this.http.delete(`${this.getUrl()}/${id}`,
      { headers: headers }).pipe(catchError(this.errorHandlerService.handleError))
    await firstValueFrom(result)
  }
}
